import React from 'react';

import analyticService from 'services/analytics';

import './breadcrumbs.scss';

let breadcrumbNode;
const maxBreadcrumbs = 5;

const Breadcrumbs = ({ history, location, tableName, service }) => {
	let maxLength;
	const textToPixelValue = 8; // 1 letter translates to approx 8px width

	const truncateBreadcrumbs = (maxLength) => {
		service.breadcrumbs.forEach((crumb, i) => {
			crumb.name = crumb.name.length > maxLength ?
				`${crumb.name.slice(0, maxLength).trim()}...` : crumb.name;
		});
	};

	/*
	 * Compare width of h2 element against length of breadcrumbs,
	 * determine if we need to truncate
	 */
	const compareWidths = () => {
		const containerWidth = breadcrumbNode.getBoundingClientRect().width;
		const breadcrumbsLength = service.breadcrumbs.reduce((agg, crumb) => {
			agg += crumb.name.length;
			return agg;
		}, 0) * textToPixelValue;

		if (breadcrumbsLength > containerWidth) {
			const containerLength = containerWidth / textToPixelValue;
			const totalLength = containerLength - service.breadcrumbs[0].name.length;
			maxLength = Math.floor(totalLength / (service.breadcrumbs.length - 1));
			truncateBreadcrumbs(maxLength);
		}
	};

	if (service.breadcrumbs.length > maxBreadcrumbs) {
		service.breadcrumbs.shift();
	}

	if (breadcrumbNode) {
		compareWidths();
	}

	const breadcrumbs = service.breadcrumbs.map((crumb, i, arr) => {
		const isLastCrumb = i === arr.length - 1;
		const divider = !isLastCrumb ? <span className="divider">></span> : null;
		const onBreadcrumbClick = () => {
			if (isLastCrumb) return;

			service.breadcrumbClicked = true;

			const gaEvent = `Breadcrumb Return to ${crumb.path}`;
			analyticService.trackEvent('Mega Tables', 'Click', gaEvent);
			service.breadcrumbs = service.breadcrumbs.slice(0, i + 1);
			history.push({
				pathname: crumb.path,
				search: crumb.search,
			});
		};

		return (
			<>
				<div className={`breadcrumb${isLastCrumb ? ' last' : ''}`}>
					<p className="header">{crumb.header}</p>
					<p className="text" onClick={onBreadcrumbClick}>
						{crumb.name}
					</p>
				</div>
				{divider}
			</>
		);
	});

	return (
		<div className="breadcrumbs-container"
			ref={(node) => breadcrumbNode = node}>
			{breadcrumbs}
		</div>
	);
};

export default Breadcrumbs;
